import React, { FC } from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Footer from 'evcharging/containers/layout/Footer';
import { I18nPage } from 'i18n/types/pages.enum';
import { getShopProduct } from 'evcharging/services/cmsClient';
import { ShopProduct } from 'evcharging/services/types';
import Section from 'evcharging/containers/layout/Section';
import ShopOrderForm from 'containers/shop/product/ShopOrderForm';
import Container from 'evcharging/components/Container';
import Responsible from 'evcharging/components/Responsible';
import ShopCard from 'containers/shop/ShopCard';
import Spacer from 'evcharging/components/Spacer';
import Title from 'evcharging/components/Title';

interface ProductPageProps extends StaticPageProps {
  product: ShopProduct,
}

const category = 'thermostats';
const baseUrl = '/services/thermostat';

const ProductPage: FC<ProductPageProps> = (props) => {
  const { product } = props;

  return (
    <Page
      locales={['en']}
      title={product.name}
      description={product.name}
    >
      <Navigation />
      <Section background={'middle'}>
        <Container>
          <Spacer value={0} mobile={70} />
          <Title color={'middle'}>Make Order</Title>
          <Spacer value={36} />
          <Responsible fractions={[35, 60]} space={50}>
            <ShopCard baseUrl={baseUrl} product={product} />
            <ShopOrderForm product={product} />
          </Responsible>
        </Container>
      </Section>
      <Footer />
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, async (context, locale) => {
    const { params } = context;
    const { product: link } = params;

    const product = await getShopProduct(category, String(link));

    return { product };
  },
  [I18nPage.AboutUs, I18nPage.Home, I18nPage.EvChargingCommon]
);

export default ProductPage;
